module.exports = __webpack_public_path__ + "static/footer-40e3b64109acca5f138da543e538e46e.png";